function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "11",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.016 5.432C.016 2.437 2.277 0 5.057 0 7.837 0 10.1 2.437 10.1 5.432c0 3.718-4.512 9.175-4.704 9.406a.433.433 0 01-.675 0C4.527 14.608.016 9.15.016 5.432zm2.505 0c0 1.507 1.138 2.734 2.536 2.734 1.399 0 2.537-1.226 2.537-2.734 0-1.507-1.138-2.733-2.537-2.733-1.398 0-2.536 1.226-2.536 2.733z"
})));